exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "canvas[data-v-73c607d6]{width:100%;height:350px}", ""]);

// exports
